import React, { useState } from 'react'
import "./TopReviews.css";
import Review_Card from './review_card/Review_Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleUp } from '@fortawesome/free-solid-svg-icons';

const TopReviews = ({all_review}) => {

    const top_reviews = [
        {
            name: "John Doe",
            image: "/assets/images/products/img1.png",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            date: "05/11/2024"
        },

        {
            name: "John Doe",
            image: "/assets/images/products/img1.png",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            date: "05/11/2024"
        },

        {
            name: "John Doe",
            image: "/assets/images/products/img1.png",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            date: "05/11/2024"
        },
        {
            name: "John Doe",
            image: "/assets/images/products/img1.png",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            date: "05/11/2024"
        },

        {
            name: "John Doe",
            image: "/assets/images/products/img1.png",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            date: "05/11/2024"
        },

        {
            name: "John Doe",
            image: "/assets/images/products/img1.png",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            date: "05/11/2024"
        },


    ]

    const [showAll, setShowAll] = useState(false);

    const displayedReviews = showAll ? all_review : all_review.slice(0, 3);




    return (
        <div className='TopReviews'>
            <p className='section_title'>Top {showAll ? top_reviews.length : 3} Reviews</p>

            <div className='review_card_holder'>
                {all_review?.map((review, index) => (
                    <Review_Card key={index} review={review} />
                ))}
            </div>

            {all_review?.length > 3 &&( <div className='show_all_text' onClick={() => setShowAll(!showAll)}>
                <p>
                    {showAll ? "View Less" : "View All"}{" "}
                    <FontAwesomeIcon icon={faAngleRight} className='righticon' />
                </p>
            </div>)}
           
        </div>
    )
}

export default TopReviews
